import { graphql, readInlineData } from "react-relay";

import { isStyleSectionContent } from "~/components/section/section-style/helpers";
import type { helpersStyleSectionContent$key } from "~/queries/__generated__/helpersStyleSectionContent.graphql";

export const checkIsStyleSectionContent = (reference: helpersStyleSectionContent$key) => {
  const section = readInlineData(
    graphql`
      fragment helpersStyleSectionContent on Section @inline {
        fullSectionPath {
          entityId
        }
      }
    `,
    reference,
  );

  const sectionEntityIds = section?.fullSectionPath?.flatMap(s => s?.entityId ?? []) ?? [];
  return isStyleSectionContent(sectionEntityIds);
};
